import * as actionTypes from 'modules/Notifications/redux/actionTypes';

export const initializeNotifications = (payload) => ({
  type: actionTypes.INITIALIZE_NOTIFICATIONS,
  payload,
});

export const showSidebar = (payload) => ({ type: actionTypes.SHOW_SIDEBAR, payload });

export const hideSidebar = (payload) => ({ type: actionTypes.HIDE_SIDEBAR, payload });

export const getNotifications = (payload) => ({ type: actionTypes.NOTIFICATIONS, payload });

export const getNotificationsSuccess = (data, skipHasNextPageUpdate = false) => ({
  type: actionTypes.NOTIFICATIONS_SUCCESS,
  payload: { data, skipHasNextPageUpdate },
});

export const getNotificationsError = (payload) => ({
  type: actionTypes.NOTIFICATIONS_FAILURE,
  payload,
});

export const getLatestNotifications = (payload) => ({
  type: actionTypes.LATEST_NOTIFICATIONS,
  payload,
});

export const getLatestNotificationsSuccess = (payload) => ({
  type: actionTypes.LATEST_NOTIFICATIONS_SUCCESS,
  payload,
});

export const getLatestNotificationsError = (payload) => ({
  type: actionTypes.LATEST_NOTIFICATIONS_FAILURE,
  payload,
});

export const startNotificationsPolling = (payload) => ({
  type: actionTypes.START_NOTIFICATIONS_POLLING,
  payload,
});

export const stopNotificationsPolling = (payload) => ({
  type: actionTypes.STOP_NOTIFICATIONS_POLLING,
  payload,
});

export const readNotification = (payload) => ({ type: actionTypes.NOTIFICATIONS_READ, payload });

export const readNotificationSuccess = (payload) => ({
  type: actionTypes.NOTIFICATIONS_READ_SUCCESS,
  payload,
});
export const readNotificationError = (payload) => ({
  type: actionTypes.NOTIFICATIONS_READ_FAILURE,
  payload,
});

export const removeNotification = (payload) => ({
  type: actionTypes.NOTIFICATIONS_REMOVE,
  payload,
});

export const removeNotificationSuccess = (payload) => ({
  type: actionTypes.NOTIFICATIONS_REMOVE_SUCCESS,
  payload,
});

export const removeNotificationError = (payload) => ({
  type: actionTypes.NOTIFICATIONS_REMOVE_FAILURE,
  payload,
});

export const readAllNotifications = (payload) => ({
  type: actionTypes.NOTIFICATIONS_READ_ALL,
  payload,
});

export const readAllNotificationsSuccess = (payload) => ({
  type: actionTypes.NOTIFICATIONS_READ_ALL_SUCCESS,
  payload,
});

export const readAllNotificationsError = (payload) => ({
  type: actionTypes.NOTIFICATIONS_READ_ALL_FAILURE,
  payload,
});

export const removeAllNotifications = (payload) => ({
  type: actionTypes.NOTIFICATIONS_REMOVE_ALL,
  payload,
});

export const removeAllNotificationsSuccess = (payload) => ({
  type: actionTypes.NOTIFICATIONS_REMOVE_ALL_SUCCESS,
  payload,
});

export const removeAllNotificationsError = (payload) => ({
  type: actionTypes.NOTIFICATIONS_REMOVE_ALL_FAILURE,
  payload,
});

export const setWatched = (payload) => ({ type: actionTypes.NOTIFICATIONS_SET_WATCHED, payload });

export const getMoreNotifications = (payload) => ({
  type: actionTypes.NOTIFICATIONS_MORE,
  payload,
});

export const getMoreNotificationsSuccess = (payload) => ({
  type: actionTypes.NOTIFICATIONS_MORE_SUCCESS,
  payload,
});

export const getMoreNotificationsError = (payload) => ({
  type: actionTypes.NOTIFICATIONS_MORE_FAILURE,
  payload,
});

export const showToast = (payload) => ({
  type: actionTypes.SHOW_TOAST,
  payload,
});

export const dismissToast = (payload) => ({
  type: actionTypes.DISMISS_TOAST,
  payload,
});

export const queueToast = (payload) => ({
  type: actionTypes.QUEUE_TOAST,
  payload,
});

export const clearToastsQueue = (payload) => ({
  type: actionTypes.CLEAR_TOASTS_QUEUE,
  payload,
});

export const getOnLoginNotifications = (payload) => ({
  type: actionTypes.NOTIFICATIONS_ON_LOGIN,
  payload,
});

export const setUnreadCounter = (payload) => ({ type: actionTypes.SET_UNREAD_COUNTER, payload });

export const showNotificationModal = (payload) => ({ type: actionTypes.SHOW_MODAL, payload });

export const closeNotificationModal = (payload) => ({ type: actionTypes.CLOSE_MODAL, payload });
